import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  IconButton,
  Paper,
  InputBase,
  Avatar,
} from '@mui/material';


// MenuIcon was unused and removed
import SearchIcon from '@mui/icons-material/Search';
import DevicesIcon from '@mui/icons-material/Devices';
import GroupsIcon from '@mui/icons-material/Groups';
import MemoryIcon from '@mui/icons-material/Memory';
import PersonIcon from '@mui/icons-material/Person';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SettingsIcon from '@mui/icons-material/Settings';
import AlarmIcon from '@mui/icons-material/Alarm';
import StorageIcon from '@mui/icons-material/Storage';
import BuildIcon from '@mui/icons-material/Build';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { ColorModeContext } from '../theme/ColorModeContext';
import { Link, Outlet } from 'react-router-dom';
import RacsLogo from './RacsLogo';
import {
    Menu,
    MenuItem,
    ListItemText,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMsal } from '@azure/msal-react';
const drawerWidth = 72;

interface DashboardProps {
  onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
  const { mode, toggleColorMode } = React.useContext(ColorModeContext);
  const { instance: msalInstance, accounts } = useMsal();

  const [accountMenuAnchor, setAccountMenuAnchor] = React.useState<null | HTMLElement>(null);
  const accountMenuOpen = Boolean(accountMenuAnchor);

  const authMethod = sessionStorage.getItem('racs_auth_method');
  const userEmail = sessionStorage.getItem('racs_user_email');
  const userName = sessionStorage.getItem('racs_user_name');
  const userPicture = sessionStorage.getItem('racs_user_picture');

  const handleAccountMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAccountMenuAnchor(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountMenuAnchor(null);
  };

    const handleLogoutClick = async () => {
        handleAccountMenuClose();

        const wasOutlook = authMethod === 'outlook';
        const account = accounts.length > 0 ? accounts[0] : undefined;

        sessionStorage.removeItem('racs_auth_method');
        sessionStorage.removeItem('racs_user_email');
        sessionStorage.removeItem('racs_user_name');
        sessionStorage.removeItem('racs_user_picture');
        sessionStorage.removeItem('msal.interaction.status');

        onLogout();

        if (wasOutlook && account) {
            try {
                await msalInstance.logoutRedirect({ account });
                return;
            } catch (err) {
                console.error('MSAL logout error:', err);
            }
        }
    };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#0b0b0b' }}>
      
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#0b0b0b',
            color: '#9aa0a6',
            borderRight: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 2,
            top: '72px',
            height: 'calc(100% - 72px)',
          },
        }}
      >
        <List>
          {[
            { key: 'home', label: 'Home', icon: <HomeIcon />, to: '/dashboard' },
            { key: 'devices', label: 'Devices', icon: <DevicesIcon />, to: '/devices' },
            { key: 'groups', label: 'Groups', icon: <GroupsIcon />, to: '/groups' },
            { key: 'hardware', label: 'Hardware', icon: <MemoryIcon />, to: '/hardware' },
            { key: 'profiles', label: 'Profiles', icon: <PersonIcon />, to: '/profiles' },
            { key: 'roles', label: 'Roles', icon: <SupervisorAccountIcon />, to: '/roles' },
            { key: 'settings', label: 'Settings', icon: <SettingsIcon />, to: '/settings' },
            { key: 'events', label: 'Events & Alarms', icon: <AlarmIcon />, to: '/events' },
            { key: 'topology', label: 'Topology', icon: <StorageIcon />, to: '/topology' },
            { key: 'utilities', label: 'Utilities', icon: <BuildIcon />, to: '/utilities' },
          ].map(({ key, label, icon, to }) => (
            <ListItem key={key} disablePadding sx={{ display: 'flex' }}>
              <Tooltip title={label} placement="right">
                <ListItemButton component={Link} to={to} sx={{ justifyContent: 'center', px: 0, my: 1.2 }}>
                  <ListItemIcon sx={{ justifyContent: 'center', color: '#9aa0a6', minWidth: 'auto' }}>
                    {icon}
                  </ListItemIcon>
                </ListItemButton>
              </Tooltip>
            </ListItem>
          ))}
        </List>
      </Drawer>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <AppBar position="fixed" elevation={0} sx={{ backgroundColor: '#000' }}>
          <Toolbar sx={{ position: 'relative', minHeight: 76, px: 2 }}>
            <Box sx={{ position: 'absolute', left: 12, top: 12, display: 'flex', alignItems: 'center' }}>
              <RacsLogo size={40} />
            </Box>

            <Box sx={{ position: 'absolute', right: 16, display: 'flex', gap: 1, alignItems: 'center' }}>
              <IconButton color="inherit" onClick={toggleColorMode} sx={{ borderRadius: 2 }}>
                {mode === 'dark' ? (
                  <LightModeOutlinedIcon sx={{ color: '#9aa0a6' }} />
                ) : (
                  <DarkModeOutlinedIcon sx={{ color: '#555' }} />
                )}
              </IconButton>

              <IconButton color="inherit">
                <HelpOutlineIcon sx={{ color: '#9aa0a6' }} />
              </IconButton>
              <IconButton
  color="inherit"
  onClick={handleAccountMenuOpen}
  aria-controls={accountMenuOpen ? 'account-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={accountMenuOpen ? 'true' : undefined}
>
                  {userPicture ? (
                      <Avatar
                          src={userPicture}
                          imgProps={{ referrerPolicy: 'no-referrer' }}
                          sx={{ width: 28, height: 28 }}
                      />
                  ) : (
                      <AccountCircle sx={{ color: '#9aa0a6' }} />
                  )}
</IconButton>

<Menu
  id="account-menu"
  anchorEl={accountMenuAnchor}
  open={accountMenuOpen}
  onClose={handleAccountMenuClose}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
>
  {(userName || userEmail) && (
    <MenuItem disabled divider sx={{ opacity: '1 !important' }}>
      <ListItemText
        primary={userName || userEmail}
        secondary={userEmail && userName ? userEmail : undefined}
      />
    </MenuItem>
  )}
  <MenuItem onClick={handleLogoutClick}>
    <ListItemIcon>
      <LogoutIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText>Logout</ListItemText>
  </MenuItem>
</Menu>
            </Box>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 2, mt: '72px' }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#171717',
              borderRadius: 1,
              p: 2,
              minHeight: '68vh',
              color: '#e0e0e0',
              overflow: 'auto',
              width: '100%',
            }}
          >
            <Outlet />
          </Paper>
        </Box>
      </Box>
    </Box>
  );

};

export default Dashboard;
